import { FC } from 'react';

import { ConfirmationModal } from '../../../../../../../shared/components';

interface ModalDeleteTabProps {
  onCancel: () => void;
  onOk: () => void;
  open: boolean;
}

export const ModalDeleteTab: FC<ModalDeleteTabProps> = ({
  onCancel,
  onOk,
  open,
}) => {
  return (
    <ConfirmationModal
      open={open}
      onCancel={onCancel}
      onConfirm={onOk}
      confirmButtonLabel='Eliminar'
      title='¿Desea eliminar el bien?'
      description='Si elimina el bien, quedará eliminado definitivamente y tendrá que volver a cargar de vuelta todos los datos del mismo. ¿Desea continuar?'
    />
  );
};
